export const BAG_ADD_BRA = "BAG_ADD_BRA";
export const BAG_ADD_GIFT = "BAG_ADD_GIFT";
export const BAG_REMOVE_ITEM = "BAG_REMOVE_ITEM";
export const BAG_SAVE_SHIPPING_INFO = "BAG_SAVE_SHIPPING_INFO";
export const BAG_SAVE_CUSTOMER_EMAIL = "BAG_SAVE_CUSTOMER_EMAIL";
export const SET_BAG_TO_EMPTY_STATE = "SET_BAG_TO_EMPTY_STATE";
export const BAG_APPLY_PROMO_CODE = "BAG_APPLY_PROMO_CODE";
